//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[[0,"Geom",0,"NXObject",0]],[[["zone_name","method","waist_flex_angle_data","waist_flex_range_lower_data","waist_flex_range_upper_data","waist_lateral_angle_data","waist_lateral_range_lower_data","waist_lateral_range_upper_data","trace_site_name","human","resolution","assoc_reach_zone"],"SetData",{},12,0],[["zone_name","method","waist_flex_angle_data","waist_flex_range_lower_data","waist_flex_range_upper_data","waist_lateral_angle_data","waist_lateral_range_lower_data","waist_lateral_range_upper_data","trace_site_name","human","resolution","assoc_reach_zone"],"GetData",{},0,0],[["reach_zone_name"],"ChangeName",{},1,0]],[]];
SPLM.HumanReachZone = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.HumanReachZone";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.HumanReachZone.MethodType = Object.freeze({
    "ShoulderOnly" : "ShoulderOnly", "FlexWaist" : "FlexWaist"});

export default SPLM;